// extracted by mini-css-extract-plugin
module.exports = {"name":"dece2e673c--name--QgzdN","phone":"dece2e673c--phone--AziBU","note":"dece2e673c--note--Xvc75","button":"dece2e673c--button--h8VUl"};